export default function ({ redirect, $auth, i18n }) {
    if (!$auth.loggedIn) { return }


    if ($auth.user.data?.verified) {
        const locale = i18n.locale === i18n.defaultLocale ? '' : '/' + i18n.locale;
        redirect(`${locale}/order`)
    }
}
